import * as React from "react";
import { useAppSelector } from "../../../store/hooks";
import { store } from "../../../store";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props {
  checker: (initial: any, values: any) => void;
}
export const CpFormDirtyChecker = ({ checker }: Props): React.ReactElement => {
  const { id } = useCpFormContext();
  const onChangeCounter: any = useAppSelector((state) => state.form.instances[id].meta.onChangeCounter);
  const onBlurCounter: any = useAppSelector((state) => state.form.instances[id].meta.onBlurCounter);

  React.useEffect(() => {
    checkDirty();
  }, [onChangeCounter, onBlurCounter]);

  async function checkDirty() {
    const initial = store.getState().form.instances[id].initialValues;
    const current = store.getState().form.instances[id].values;
    checker(initial, current);
  }

  return <></>;
};
